import { SubmitFeedbackResponseSchema, } from '@packages/types';
import { api } from '../client.js';
export function submitFeedback(input) {
    return api('/feedback', SubmitFeedbackResponseSchema, {
        method: 'POST',
        body: input,
    });
}
